(function ($) {

    $(document).ready(function () {

        $(".read-more").on("click", function () {
            $(this).closest(".section_goals_section").find(".column + .column").slideDown("slow");
            $(this).remove();
        })

    });

})(jQuery);